import Vue from 'vue'
import { BosClient, Q } from '@baiducloud/sdk'
import * as asyncThree from 'async'
import { uploadFileBosGetPrefix } from './../api/system/file'

export async function uploadFile (
  file,
  progress = undefined,
  bucket = 'guojidasai'
) {

  console.log("vue123123",Vue);
  const client = new BosClient({
    endpoint: 'https://bj.bcebos.com',
    credentials: {
      ak: '9b7f9270b2f0455baca5152ed607bb29',
      sk: '4c1a0aab14e643aeb4b683e1cd31c53f'
    }
  })

  client.on('progress', function (evt) {
    // 监听上传进度
    if (evt.lengthComputable) {
      // 添加您的代码
      var percentage = (evt.loaded / evt.total) * 100
      console.log('上传中，已上传了' + percentage + '%', evt)
    }
  })

  let PART_SIZE = 1 * 1024 * 1024 // 指定分块大小

  function getTasks (file, uploadId, bucketName, key) {
    let leftSize = file.size
    let offset = 0
    let partNumber = 1

    let tasks = []

    while (leftSize > 0) {
      let partSize = Math.min(leftSize, PART_SIZE)
      tasks.push({
        file: file,
        uploadId: uploadId,
        bucketName: bucketName,
        key: key,
        partNumber: partNumber,
        partSize: partSize,
        start: offset,
        stop: offset + partSize - 1
      })

      leftSize -= partSize
      offset += partSize
      partNumber += 1
    }
    return tasks
  }

  function uploadPartFile (state, client) {
    return function (task, callback) {
      let blob = task.file.slice(task.start, task.stop + 1)
      client
        .uploadPartFromBlob(
          task.bucketName,
          task.key,
          task.uploadId,
          task.partNumber,
          task.partSize,
          blob
        )
        .then(function (res) {
          ++state.loaded
          callback(null, res)
          typeof progress === 'function' && progress({
            percent: parseInt(state.loaded / state.total * 100)
          })
        })
        .catch(function (err) {
          callback(err)
        })
    }
  }

  let uploadId
  const timestamp = new Date().getTime()
  const res = await uploadFileBosGetPrefix(Vue.prototype.systemURL, file.name)
  const prefix = res.data || `unknown/`
  const key = `${prefix}${timestamp}_${file.name}`
  return client
    .initiateMultipartUpload(bucket, key, {})
    .then(function (response) {
      uploadId = response.body.uploadId // 开始上传，获取服务器生成的uploadId

      let deferred = Q.defer()
      let tasks = getTasks(file, uploadId, bucket, key)
      let state = {
        lengthComputable: true,
        loaded: 0,
        total: tasks.length
      }

      // 为了管理分块上传，使用了async（https://github.com/caolan/async）库来进行异步处理
      let THREADS = 2 // 同时上传的分块数量
      asyncThree.mapLimit(tasks, THREADS, uploadPartFile(state, client), function (
        err,
        results
      ) {
        if (err) {
          deferred.reject(err)
        } else {
          deferred.resolve(results)
        }
      })
      return deferred.promise
    })
    .then(function (allResponse) {
      let partList = []
      allResponse.forEach(function (response, index) {
        // 生成分块清单
        partList.push({
          partNumber: index + 1,
          eTag: response.http_headers.etag
        })
      })
      return client.completeMultipartUpload(bucket, key, uploadId, partList) // 完成上传
    })
}



// WEBPACK FOOTER //
// ./src/utils/BaiduBosUploader.js